import React, { useState, useEffect } from "react";
import Navbar from "./navbar";
import Home from "./home";
import Client from "./client";
import Services from "./services";
import Products from "./products";
import Counter from "./counter";
import Contact from "./contact";
import Footer from "./footer";
import logolight from "./../../../assets/images/logo-light.png";
import WhatMakesUsDifferent from "./WhatMakesUsDifferent";
import "./index.scss"; // SCSS file for styling

const Index = () => {
  const [showCover, setShowCover] = useState(true);

  document.title = "CODEPLAYERS BUSINESS SYSTEM PRIVATE LIMITED";

  useEffect(() => {
    // Wait for 3 seconds before hiding the cover
    const timer = setTimeout(() => {
      setShowCover(false); // Hide cover after 3 seconds
    }, 1500);

    window.onscroll = function () {
      scrollFunction();
    };

    return () => {
      clearTimeout(timer);
      window.onscroll = null; // Cleanup on unmount
    };
  }, []);

  const scrollFunction = () => {
    const element = document.getElementById("back-to-top");
    if (element) {
      if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
        element.style.display = "block";
      } else {
        element.style.display = "none";
      }
    }
  };

  const toTop = () => {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  };

  return (
    <React.Fragment>
      {showCover && (
        <div className="cover-page d-flex align-items-center justify-content-center">
          <div className="text-center">
            <img
              src={logolight}
              alt="CodePlayers Logo"
              className="cover-logo"
            />
          </div>
        </div>
      )}
      {!showCover && (
        <div className="layout-wrapper landing">
          <Navbar/>
          <Home />
          <Client />
          <Services />
          <WhatMakesUsDifferent />
          <Products />
          <Counter />
          <Contact />
          <Footer />
          <button
            onClick={() => toTop()}
            className="btn btn-danger btn-icon landing-back-top"
            id="back-to-top"
          >
            <i className="ri-arrow-up-line"></i>
          </button>
        </div>
      )}
    </React.Fragment>
  );
};

export default Index;
